/**
 * Singleton store for the AWS region currently serving the GA-routed backend.
 *
 * The value is sourced from the `X-Served-Region` response header that
 * api.py's middleware stamps on every response. Pumped by whichever
 * GA-routed poll the app already runs (currently the 30s announcement
 * fetcher in ChatInterface). useServedRegion subscribes here instead of
 * making its own /health poll, eliminating one 15s network round-trip per
 * session — including on customer embeds where the consuming UI
 * (ExperimentBadge) is hidden but the hook still runs.
 */

type Listener = (region: string | null) => void;

class ServedRegionService {
  private region: string | null = null;
  private listeners: Set<Listener> = new Set();

  get(): string | null {
    return this.region;
  }

  set(region: string | null): void {
    if (region === this.region) return;
    this.region = region;
    for (const l of this.listeners) l(region);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const servedRegionService = new ServedRegionService();
